
// used for testing purpose
const collection = [
	{
		id: 0,
		name: 'Title with icon and actions',
		description: 'Simple row with icon and actions',
	},
	{
		id: 1,
		name: 'Title without actions',
		description: 'Simple row without actions',
	},
];

export default collection;
